import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { SelectionChangeEvent } from '../../domain/selectable.domain';

@Component({
  selector: 'td-wb-card-primary-action',
  templateUrl: 'card-primary-action.component.html',
  styleUrls: ['card-primary-action.component.scss'],
  host: {
    '[attr.tabindex]': '0',
    '[attr.role]': '"button"',
    '[attr.aria-label]': 'ariaLabel()',
    '(click)': 'onClick()',
    '(keydown.space)': 'onClick()',
    '(keydown.enter)': 'onClick()'
  }
})
export class CardPrimaryActionComponent {
  readonly action: OutputEmitterRef<SelectionChangeEvent<CardPrimaryActionComponent>>
    = output<SelectionChangeEvent<CardPrimaryActionComponent>>();

  readonly ariaLabel: InputSignal<string> = input<string>('', { alias: 'aria-label' });

  protected onClick(): void {
    this.action.emit(new SelectionChangeEvent<CardPrimaryActionComponent>(this, true));
  }
}
